<template>
    <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
                  <div class="card">
                     <div class="card-header d-flex justify-content-between">
                        <div class="header-title">
                           <h4 class="card-title">배대지 사용자 현황</h4>
                        </div>
                     </div>
                     <div class="card-body">
                        <div>
                           <label>사용자등록(쿠플러스 이메일주소)</label>
                           <input type="text" class="form-control" aria-label="" v-model="regEmail" @change="activeemail" style="text-align:center;">
                        </div>
                        <div class="table-responsive">
                           
                           <table id="user-list-table" class="table table-striped dataTable mt-4" role="grid" aria-describedby="user-list-page-info">
                           <thead>
                                 <tr class="ligth">
                                    <th>Name</th>
                                    <th>Contact</th>
                                    <th>Email</th>
                                    <th>Status</th>
                                    <th>Company ID</th>
                                    <th>Join Date</th>
                                    <th>Memo</th>
                                    <th style="min-width: 100px">Authority</th>
                                 </tr>
                           </thead>
                           <tbody>
                                 <tr v-for="(userlist, index) in userlists" :key="index">
                                    <td>{{userlist.name}}</td>
                                    <td>{{userlist.phone}}</td>
                                    <td>{{userlist.email}}</td>
                                    <td><span :class="[badge,bgcolor(userlist.approval)]">{{userlist.approval}}</span></td>
                                    <td>{{userlist.companyid}}</td>
                                    <td>{{userlist.regdate}}</td>
                                    <td><input type="text" class="form-control" aria-label="" v-model="userlist.memo" @change="changeusermemo(userlist)" style="text-align:center;"></td>
                                    <td>
                                       <div class="flex align-items-center list-user-action" v-b-modal="modalID(index)">
                                          <a class="btn btn-sm bg-primary mr-1" v-b-tooltip.top title="Edit"  href="#"><i class="ri-pencil-line mr-0 "></i></a>
                                             <b-modal :id="'modal'+index" size="xl" :title="'권한수정 — ' + userlist.email" ok-title="OK" cancel-title="Close" @show="openAuth(userlist)">
                                                 <b-form @submit="onSubmit($event, userlist)" @reset="onReset">
                                                   
                                                   <b-form-group id="input-group-4" label="Food:" label-for="checkboxes-4">
                                                      <b-form-checkbox-group
                                                         v-model="auth"
                                                         id="checkboxes-4"
                                                         :aria-describedby="ariaDescribedby"
                                                      >
                                                      {{auth}}
                                                      <b-form-checkbox value="product">Products</b-form-checkbox>
                                                      <b-form-checkbox value="polist">PO List</b-form-checkbox>
                                                      <b-form-checkbox value="stock">Stock</b-form-checkbox>
                                                      <b-form-checkbox value="purchase">Purchases</b-form-checkbox>
                                                      <b-form-checkbox value="return">Returns</b-form-checkbox>
                                                      <b-form-checkbox value="admin">Admin function(Userlist, Reports)</b-form-checkbox>
                                                   </b-form-checkbox-group>
                                                   </b-form-group>

                                                   <b-button type="submit" variant="primary">Submit</b-button>
                                                   <b-button type="reset" variant="danger">Reset</b-button>
                                                </b-form>
                                                <p v-if="authMessage" class="mt-2 mb-0">{{ authMessage }}</p>

                                             </b-modal>

                                       </div>
                                    </td>
                                 </tr>
                                 
                           </tbody>
                           </table>
                        </div>
                           <!-- <div class="row justify-content-between mt-3">
                              <div id="user-list-page-info" class="col-md-6">
                                 <span>Showing 1 to 5 of 5 entries</span>
                              </div>
                              <div class="col-md-6">
                                 <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-end mb-0">
                                       <li class="page-item disabled">
                                          <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                       </li>
                                       <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                       <li class="page-item"><a class="page-link" href="#">2</a></li>
                                       <li class="page-item"><a class="page-link" href="#">3</a></li>
                                       <li class="page-item">
                                          <a class="page-link" href="#">Next</a>
                                       </li>
                                    </ul>
                                 </nav>
                              </div>
                           </div> -->
                     </div>
                  </div>
            </div>
         </div>
      </div>
</template>
<script>
import axios from 'axios';
export default {
   name:'UserList',
   data() {
      return {
         userlists:[],
         auth:[],
         authMessage:'',
         regEmail:'',
      }
   },
   methods: {
      // 서버 응답·오류 → 사람이 읽을 글(응답 객체를 그대로 띄우지 않는다)
      failText(e, fallback){
         const d = (e && e.response && e.response.data) || e || {}
         if (d.res === 'No User Information') return '그 이메일로 가입한 계정이 없어요.'
         return d.message || d.error && typeof d.error === 'string' && d.error || fallback
      },
      activeemail(){
         if(!this.regEmail){
            alert('이메일주소를 입력해 주세요')
            return
         } else {
            axios.post('/api/activeUserEmail',{email: this.regEmail})
             .then(result => {
               if(result.data.res == 'success'){
                  this.userlists.unshift(result.data.result);
               } else {
                  alert(this.failText(result.data, '사용자를 등록하지 못했어요.'))
               }
            })
             .catch(e => { console.error('activeUserEmail 실패', e); alert(this.failText(e, '사용자를 등록하지 못했어요. 잠시 뒤 다시 해 주세요.')) })
         }
      },
      // 메모 — 대상 계정의 memo 만 저장(서버 updateUserList: 회사 3곳·화주 계정·memo·chatLink 만)
      changeusermemo(userlist){
         axios.post('/api/updateUserList', { email: userlist.email, memo: userlist.memo })
            .then(result => {
               if (result.data.res !== 'success') alert(this.failText(result.data, '메모를 저장하지 못했어요.'))
            })
            .catch(e => { console.error('updateUserList 실패', e); alert(this.failText(e, '메모를 저장하지 못했어요. 잠시 뒤 다시 해 주세요.')) })
      },
      // 권한 모달 열 때 — 그 계정의 지금 권한으로 체크를 채운다
      openAuth(userlist){
         const a = userlist.auth || {}
         this.authMessage = ''
         this.auth = ['product', 'polist', 'stock', 'purchase', 'return'].filter(k => a['show' + k] === true).concat(a.showadmin === true ? ['admin'] : [])
      },
      modalID(index) {
         return 'modal' + index
      },
      bgcolor(approval){
         if(approval == true) {
            return 'bg-success'
         } else {
            return 'bg-secondary'
         }
      },
      // 권한 수정 — 대상 계정(userlist)의 권한만. 서버 userauthupdate: 개발자만 · 화이트리스트 키만 · 자기 권한 상향 거절 · 이력
      onSubmit(event, userlist) {
         event.preventDefault()
         if (this.auth.length > 0){
            var authobject = {
               showdashboard : true,
               showproduct : this.auth.includes("product"),
               showpolist : this.auth.includes("polist"),
               showstock : this.auth.includes("stock"),
               showpurchase : this.auth.includes("purchase"),
               showreturn : this.auth.includes("return"),
               showadmin : this.auth.includes("admin")
            };
            this.authMessage = '저장 중…'
            axios.post('/api/userauthupdate',{email: userlist.email, auth : authobject})
             .then(result => {
               const changed = Object.keys((result.data && result.data.changed) || {})
               this.$set(userlist, 'auth', { ...(userlist.auth || {}), ...authobject })
               this.authMessage = changed.length ? `권한을 바꿨어요(${changed.length}개).` : '바뀐 권한이 없어요.'
             })
             .catch(e => { console.error('userauthupdate 실패', e); this.authMessage = this.failText(e, '권한을 바꾸지 못했어요.') })
         }
      },
      onReset(event) {
         event.preventDefault();
         this.auth = [];
      },  
   },
   mounted() {
      this.$nextTick(function () {
         if(this.$store.state.user.auth.showadmin == true) {
            axios.post('/api/userlist',{companyid : this.$store.state.user.companyid})
            .then(result => {
               if(result.data.res == 'success'){
                  result.data.result.forEach(e => {
                     if(!e.memo){
                        e.memo = ''
                     }
                  })
                  this.userlists = result.data.result
               } else {
                  alert(this.failText(result.data, '사용자 목록을 불러오지 못했어요.'))
               }
            })
            .catch(e => { console.error('userlist 실패', e); alert(this.failText(e, '사용자 목록을 불러오지 못했어요. 잠시 뒤 다시 열어 주세요.')) })
         }
      })
   }

}
</script>
